<template>
  <a-modal
    :get-container="modalRef"
    v-model:visible="visible"
    :mask-closable="false"
    title="添加月租套餐"
    :after-close="afterClose"
  >
    <template #footer>
      <a-button :disabled="disabled" @click="visible = false">取消</a-button>
      <a-button :disabled="disabled" type="primary" @click="doSubmit"
      >确定</a-button
      >
    </template>
    <a-form :label-col="{ span: 4 }">
      <a-form-item label="套餐名称" v-bind="validateInfos.packageName">
        <a-input
          v-model:value="monthlyRentalPackageVo.packageName"
          :maxlength="16"
          placeholder="请输入套餐名称"
          allow-clear
        ></a-input>
      </a-form-item>
      <a-form-item label="选择车场" v-bind="validateInfos.parkingLotId">
        <a-select
          v-model:value="monthlyRentalPackageVo.parkingLotId"
          notFoundContent="暂无数据"
          placeholder="请选择"
          mode="multiple"
          allow-clear
        >
          <a-select-option
            v-for="item in parkingLotList"
            :key="item.id"
            :value="item.id"
          >{{ item.name }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item label="套餐类型" v-bind="validateInfos.packageType">
        <a-select
          v-model:value="monthlyRentalPackageVo.packageType"
          placeholder="请选择"
          :maxlength="5"
          allow-clear
          :options="packageTypes"
        >
        </a-select>
      </a-form-item>
      <a-form-item label="套餐金额" v-bind="validateInfos.packagePayAmount">
        <a-input
          v-model:value="monthlyRentalPackageVo.packagePayAmount"
          :maxlength="16"
          placeholder="请输入套餐金额"
          allow-clear
        >
          <template #addonAfter> 元 </template>
        </a-input>
      </a-form-item>

    </a-form>
  </a-modal>
</template>

<script>
import { ref, onMounted, toRefs } from "vue";
import useValidateRules from "@/hooks/useValidateRules";
import useMessage from "@/hooks/useMessage";
import { Form } from "ant-design-vue";
import { save } from "@/api/parking/monthlyRentalPackage";
import useMonthlyRentalPackage from "../../../../hooks/parking/useMonthlyRentalPackage";

const useForm = Form.useForm;
export default {
  name: "Add",
  props: ["modalRef"],
  emits: ["close"],
  setup(pros, { emit }) {
    const disabled = ref(false);
    const { getParkingLotList, parkingLotList, monthlyRentalPackageVo, packageTypes,moneyZ } = useMonthlyRentalPackage();
    const { monthlyRentalPackageRules } = useValidateRules();
    const { showErr, showConfirm, showLoading, closeLoading, showTipMessage } =
      useMessage();
    const { validateInfos, validate } = useForm(
      monthlyRentalPackageVo,
      monthlyRentalPackageRules,
    );
    const visible = ref(true);
    let refresh = false;
    const afterClose = () => {
      emit("close", refresh);
    };
    const doSubmit = () => {
      validate().then(async () => {
        let action = await showConfirm("添加新的月租套餐?");
        if (action) {
          disabled.value = true;
          await showLoading();
          try {
            let obj = {
              packageName: monthlyRentalPackageVo.packageName,
              packagePayAmount: moneyZ(monthlyRentalPackageVo.packagePayAmount),
              packageType: monthlyRentalPackageVo.packageType,
              parkingLotId: (monthlyRentalPackageVo.parkingLotId).join(','),
            };
            await save(obj);
            await closeLoading();
            await showTipMessage("添加成功");
            refresh = true;
            visible.value = false;
          } catch (e) {
            await closeLoading();
            await showErr(e);
            disabled.value = false;
          }
        }
      });
    };
    onMounted(async () => {
      getParkingLotList();
    });
    return {
      ...toRefs(pros),
      disabled,
      visible,
      afterClose,
      getParkingLotList,
      parkingLotList,
      packageTypes,
      validateInfos,
      monthlyRentalPackageVo,
      doSubmit,
      moneyZ,
    };
  },
};
</script>

<style scoped></style>
